import React from 'react'
import ContactContent from '../Components/contactContent/ContactContent'

const Contact = () => {
  return (
    <div className="contact">
      <h1 className="text-center">Contact</h1>
      <div className="container">
        <ContactContent />
      </div>
    </div>
  )
}

export default Contact
